export class ViewCounterUpdatedEvent {
    public constructor(
        public viewId: number,
        public increment: number
    ) {}
}
